import { render, staticRenderFns } from "./TextSubjectBody.vue?vue&type=template&id=06dc7440&lang=pug"
import script from "./TextSubjectBody.vue?vue&type=script&lang=js"
export * from "./TextSubjectBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports